// extracted by mini-css-extract-plugin
export var progressBar = "_ih-0";
export var progressBarInner = "_ih-1";